import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        'h-9 w-full rounded-sm border border-strong bg-surface px-3 text-[13px] text-gray-900',
        'placeholder:text-gray-500',
        'focus-visible:border-brand-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-800/25',
        'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-gray-500',
        invalid &&
          'border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500/20',
        className,
      )}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  )
})
